/* eslint-disable prettier/prettier */
import {API, BASE_URL} from '@/services/api/api';
import moment from 'moment';
import Vue from 'vue';

export const Utils = {
  DeckStartPoints: {X: 0, Y: 0},
  DeckEndPoints: {X: 0, Y: 0},
  validateName(name: string): boolean {
    let regex = /^(?![\s]+$)[0-9a-zA-Z\s._]{6,40}$/;
    return regex.test(String(name).trim().toLowerCase());
  },

  testRegex(name: string): boolean {
    let regex = /^([0-9+-/.()]{1,100})$/;
    return regex.test(String(name));
  },

  validateEmail(email: string): boolean {
    let regex = /^(([^<>()[\]\\,;:\s@"]+(\.[^<>()[\]\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).trim().toLowerCase());
  },
  validatePassword(password: string): boolean {
    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,20}$/;
    return regex.test(password);
  },
  //globally used date format
  formatDate(date: string | Date): string {
    return moment(date).format('DD MMM YYYY');
  },
  //return base64 url of blob
  async ngxBase64(imageBlob: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        resolve(reader.result);
        return reader.result;
      });
      if (imageBlob) {
        reader.readAsDataURL(imageBlob);
      }
      reader.onerror = function (error) {
        return null;
      };
    });
  },
  isUserLoggedIn(): boolean {
    var token = sessionStorage.getItem('access_token');
    return token ? token !== '' : false;
  },
  sortData(asdcOrder: any, header: any, data: any[]) {
    data.sort((objA: any, objB: any) => {
      let valueA = objA[header.value] ? objA[header.value] : '';
      let valueB = objB[header.value] ? objB[header.value] : '';
      if (header.headerType === 'text') return this.compareString(valueA, valueB, asdcOrder);
      else if (header.headerType === 'number') return this.compareNumber(valueA, valueB, asdcOrder);
      else if (header.headerType === 'date' && asdcOrder) return this.compareDate(valueA, valueB);
      else return this.compareDate(valueB, valueA);
    });
    return !asdcOrder;
  },
  compareString(valueA: string, valueB: string, asdcOrder: boolean): number {
    const result = asdcOrder ? valueB.localeCompare(valueA) : valueA.localeCompare(valueB);
    return result;
  },

  compareNumber(valueA: number, valueB: number, asdcOrder: boolean) {
    const result = asdcOrder ? valueB - valueA : valueA - valueB;
    return result;
  },
  compareDate(dateAStr: string, dateBStr: string): number {
    let dateA = new Date(dateAStr);
    let dateB = new Date(dateBStr);

    if (dateA.getTime() === dateB.getTime()) {
      return 0;
    } else if (dateA.getTime() < dateB.getTime()) {
      return -1;
    } else {
      return 1;
    }
  },
  calculatePassStrength(pass: string): number {
    let strength = 0;
    const passLength = pass.length;
    const format = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
    const containsNumber = /\d/.test(pass);
    const containsUppercase = /[A-Z]/.test(pass);
    const containsSpecialChar = format.test(pass);
    if (passLength) ++strength;
    if (containsNumber) ++strength;
    if (containsUppercase) ++strength;
    if (containsSpecialChar) ++strength;
    return strength;
  },
  roleGroupPage(groupId) {
    const permissions = [
      {pageGroupID: 1, pageGroupName: 'Inspection'},
      {pageGroupID: 2, pageGroupName: 'Inspection Report'},
      {pageGroupID: 3, pageGroupName: 'Re-Inspection'},
      {pageGroupID: 4, pageGroupName: 'Ships'},
      {pageGroupID: 5, pageGroupName: 'Action Plan'},
    ];
    return permissions.find((per) => per.pageGroupID === groupId);
  },
  roleGroupAuthority(authId) {
    const auth = [
      {
        authoritiesId: 1,
        authorityName: 'Read',
      },
      {
        authoritiesId: 2,
        authorityName: 'Create',
      },
      {
        authoritiesId: 3,
        authorityName: 'Edit',
      },
      {
        authoritiesId: 4,
        authorityName: 'Delete',
      },

      {
        authoritiesId: 5,
        authorityName: 'Delete Entire Inspections',
      },
    ];
    return auth.find((per) => per.authoritiesId === authId);
  },

  keyDownEvent(event, cropper) {
    let e = event || window.event;

    if (!cropper) {
      return;
    }
    switch (e.keyCode) {
      case 37:
        cropper.move(-1, 0);
        break;

      case 38:
        cropper.move(0, -1);
        break;

      case 39:
        cropper.move(1, 0);
        break;

      case 40:
        cropper.move(0, 1);
        break;
      // case 96 || 48:
      //   cropper.reset();
      //   break;
    }
  },

  parseJson(string) {
    let json = null;
    try {
      json = JSON.parse(string);
    } catch (e) {
      json = null;
    }
    return json;
  },

  async downloadImage(imageUrl: string, imageName: string) {
    try {
      const response = await API.convertImgURLToBLob(imageUrl);

      const link = document.createElement('a');
      if (response) {
        const data = response;
        const blob = new Blob([data], {type: data.type});
        link.href = window.URL.createObjectURL(blob);
        link.download = `${imageName}`;
        return link;
      }
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  getBackgroundColor(condition) {
    switch (condition) {
      case 'Medium':
        return '#FE9B0A';
      case 'High':
        return '#E23838';
      case 'Must See':
        return '#FB0AD7';
      case 'Low':
        return '#08D1FC';

      default: {
        return '#fff';
      }
    }
  },
  //Detact mouse distanse from poin
  mouseDistance(x1, y1, x2, y2) {
    let xDistance = x2 - x1;
    let yDistance = y2 - y1;
    //

    return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
  },

  /**
   *
   * @param module access module (inspectionList will be visible even it is disabled)
   * @param groupId permission group
   * @param permissionId permission id in group
   * @param levelUpto acesss upto
   * @param userRoleId usertype
   * @returns true or false
   */
  checkInspectionPermission(module, parentShipPerId, groupId, permissionId, levelUpto, userRoleId) {
    if (userRoleId == process.env?.VUE_APP_SUPER_ADMIN_ID) return true;
    
      //Inspection list will be visible to everyone even if it is disable

      if (groupId === 1 && permissionId >= levelUpto && module === 'inspectionlist') 
        return true;
      if (
        groupId === 1 &&
        parentShipPerId === 6 &&
        levelUpto > 1 &&
        levelUpto < 6 &&
        module === 'inspection' &&
        permissionId < 6
      ) {
        return false;
      }
      if (groupId === 1 && permissionId >= levelUpto && module === 'inspection' && permissionId < 6) {
        return true;
      }
      if ( (groupId === 3 || groupId === 4) && permissionId >= levelUpto && module === 'inspection'){
         return true;
      }
      return false;
    
  },

  checkAdminPanelPermission() {
    const userRoleId = Vue.prototype.$store.getters.userDetails?.type?.roleId;

    if (userRoleId == process.env?.VUE_APP_ADMIN_ID || userRoleId == process.env?.VUE_APP_SUPER_ADMIN_ID) return true;
    else return false;
  },

  checkReportPermission(permissions: any[], shipPermission) {
   
    if (!permissions || permissions.length === 0) return false;
    for (let index = 0; index < permissions.length; index++) {
      const permission = permissions[index];
      console.log(permission.pageGroupId , permission.authoritiesId, shipPermission)
      if (permission.pageGroupId === 2 && permission.authoritiesId === 7 && shipPermission !== 6) return true;
    }

    return false;
  },

  // checkReportPermission(groupId, permissionId, shipPermission) {
  // if (groupId === 2 && permissionId === 7 && shipPermission !== 6)
  //   return true;
  // else return false;
  // },

  checkReinsepctionPermission(groupId, permissionId) {
    if (groupId === 3 && permissionId === 7) return true;
    else return false;
  },
  checkActionPermission(module, groupId, permissionId) {
    if (groupId === 5 && permissionId === 2 && permissionId < 6) return true;
    if (groupId === 5 && permissionId === 1 && permissionId < 6) return true;
    
    return false;
    
  },

  getGroupIndex(module) {
    let data = [
      {id: 1, module: 'inspection', groupIndex: 0},
      {id: 2, module: 'inspectionlist', groupIndex: 0},

      {id: 3, module: 'report', groupIndex: 1},
      {id: 4, module: 'reinspection', groupIndex: 2},
      {id: 5, module: 'ships', groupIndex: 3},
      {id: 6, module: 'action', groupIndex: 4},
      {id: 7, module: 'actioncreate', groupIndex: 4},
    ];

    return data.find((me) => me.module === module).groupIndex;
  },

  manageRoutePermissions(moduleName, level = 1) {
    if (this.isSuperAdmin()) return true;
    if (moduleName === 'AdminPanel') return this.checkAdminPanelPermission();
    else {
      const permissions = Vue.prototype.$store.getters.userDetails?.permissions;

      let userRoleId = Vue.prototype.$store.getters.userDetails?.type?.roleId;
      let groupIndex = this.getGroupIndex(moduleName);
      let inspection = permissions?.[groupIndex];
      let shipGroupIndex = this.getGroupIndex('ships');
      let shipPermissions = permissions?.[shipGroupIndex];
      let shipCurrentPerId = shipPermissions?.authoritiesId;

      let groupId = inspection?.pageGroupId;
      let permissionId = inspection?.authoritiesId;
      
      switch (moduleName) {
        case 'inspectionlist':
          
          return this.checkInspectionPermission('inspectionlist', 0,  groupId, permissionId, level, userRoleId);

        case 'inspection':
          return this.checkInspectionPermission(
            'inspection',
            shipCurrentPerId,

            groupId,
            permissionId,
            level,
            userRoleId
          );

        case 'report':
          return this.checkReportPermission(permissions, shipCurrentPerId);
        case 'reinspection':
          return this.checkReinsepctionPermission(groupId, permissionId);
        case 'action':
          return this.checkActionPermission(moduleName, groupId, permissionId);
      }
    }
  },

  isSuperAdmin() {
    let userRoleId = Vue.prototype.$store.getters.userDetails?.type?.roleId;
    return userRoleId == process.env?.VUE_APP_SUPER_ADMIN_ID ? true : false;
  },

  isAdmin() {
    let userRoleId = Vue.prototype.$store.getters.userDetails?.type?.roleId;
    return userRoleId == process.env?.VUE_APP_ADMIN_ID ? true : false;
  },
};

export const getImage = async (imageGuid: string) => {
  const result = await fetch(`${BASE_URL}/images/${imageGuid}`);
  return await result.text();
};
